import styled from '@emotion/styled';
import Icon from '@mdi/react';
import { BaseButton, BaseImage, forPhoneOnly, forTabletLandscapeDown, forTabletPortraitDown, Variables } from '../base';
import { TopNav, TopNavItem, TopNavLeft, TopNavRight } from './top-nav.styles';

export const AppTopNavLogo = styled(BaseImage)`
    height: 30px;
    width: auto;
`;

/** `railed`: sits above a sidebar collapsed to its rail — the toggle alone, centred. */
export const AppTopNavLogoSection = styled.div<{ railed?: boolean }>`
    padding: ${({ railed }) => (railed ? 0 : '0 24px')};
    display: flex;
    align-items: center;
    border-right: 1px solid #dae0e7;
    width: ${({ railed }) => (railed ? Variables.sidebarRailSize : Variables.sidebarSize)};
    height: ${Variables.topnavSize};
    justify-content: ${({ railed }) => (railed ? 'center' : 'space-between')};
    transition: width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
`;

export const AppTopNavDesktopItem = styled(TopNavItem)`
    display: inline-flex;
    ${forTabletLandscapeDown(`
        display: none;
    `)};
`;

export const AppTopNavMobileItem = styled(TopNavItem)`
    display: none;
    ${forTabletLandscapeDown(`
        display: inline-flex;
    `)};
`;

export const AppTopNav = styled(TopNav)`
    display: flex;
    width: 100%;
    border-bottom: none;
    overflow: hidden;
    z-index: 1201;
    position: fixed;
    background-color: ${Variables.Colors.sidebarBackground};

    ${TopNavRight} > ${AppTopNavMobileItem},
    ${TopNavLeft} > ${AppTopNavMobileItem} {
        display: none;
    }

    ${TopNavLeft} {
        margin-left: 0;
    }

    ${forTabletLandscapeDown(`
        background-color: ${Variables.Colors.sidebarBackground};

        ${TopNavLeft} {
            margin: 0;
        }
        & > ${TopNavRight} > ${AppTopNavDesktopItem},
        & > ${TopNavLeft} > ${AppTopNavDesktopItem} {
            display: none
        }
        & > ${TopNavRight} > ${AppTopNavMobileItem},
        & > ${TopNavLeft} > ${AppTopNavMobileItem} {
            display: inline-flex;
        }
    `)};
`;

export const AppTopNavSpacer = styled.span`
    flex-grow: 1;
    display: inline-flex;
`;

export const AppTopNavIcon = styled(Icon)`
    height: 24px;
    width: 24px;
`;

export const AppTopNavSearchBarWrapper = styled.div`
    ${forTabletPortraitDown(`
        display: none;
    `)}

    & > div > div {
        background-color: #dae0e7;
        border-radius: 50px;
        border: none;
        outline: none;
        overflow: hidden;
        width: 320px;
        min-width: 320px;
    }

    & input {
        background-color: #dae0e7;
        border: none;
        outline: none;
    }

    & input:focus {
        outline: none;
        box-shadow: none;
    }
`;

export const AppTopNavSidebarToggle = styled(BaseButton)`
    min-width: 32px;
    width: 32px;
    height: 32px;
    padding: 4px;
    background-color: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background-color: ${Variables.Colors.n5};
        border-color: #dae0e7;
    }

    svg {
        fill: #3e4d64;
    }
`;

export const AppTopNavMenuButton = styled(BaseButton)`
    display: inline-flex;
    margin: 12px 24px;
    padding: 0 8px;
    min-width: unset;
    cursor: pointer;
    z-index: 100;
    fill: ${Variables.Colors.ghostWhite};

    ${forPhoneOnly(`
        margin: 12px;
    `)};
`;
